import { Stack, styled } from "@mui/material";
import { BodyTextL, BodyTextM, HeadingL } from "../Typography";

export const Label = styled(BodyTextL)(({ theme }) => ({
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(4),
}));

export const Wrapper = styled(Stack)(({ theme }) => ({
    display: "flex",
    margin: "48px auto",
    textAlign: "left",
    flexDirection: "column",
}));

export const Title = styled(HeadingL)(({ theme }) => ({
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(7),
}));

export const Paragraph = styled(BodyTextM)(({ theme }) => ({
    marginBottom: theme.spacing(7),
}));
